import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService } from 'shared-components';
import { UsuariosService } from '../../../services/usuarios.service';
import * as _timezones from 'projects/shared-components/src/lib/assets/timezone.json'
import { Subject } from 'rxjs';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component({
    selector: 'app-send-invitation-aud',
    templateUrl: './send-invitation.component.html'
})
export class SendInvitationAuditoresComponent implements OnInit {

    private _auditor;
    public sendInvitationForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();
    public toCloseSpinner = 0;

    public disabledEntidades: Subject<boolean> = new Subject();

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _usuariosService: UsuariosService,
        private readonly _sessionContext: SessionContextService
    ) { }

    ngOnInit() {
        this.sendInvitationForm = this._fb.group({
            entidad: ['', Validators.required],
            email: ['', [Validators.required, Validators.pattern('^[A-z0-9._%+-]+@[A-z0-9.-]+\\.[a-z]{2,4}$')]],
            idioma: ['', Validators.required],
            msTimeZone: ['', Validators.required],
            permisoEscritura: [false, Validators.required],
        });
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get entidadesControl() {
        if (this._dataProvider.entidadesControl.length === 1) {
            if (this._dataProvider.entidadesControl.length === 1) {
                this.sendInvitationForm.get('entidad').patchValue(this._dataProvider.entidadesControl[0]);
                this.sendInvitationForm.get('entidad').disable({onlySelf: true, emitEvent: false});
                this.disabledEntidades.next(true);
            } else {
                this.sendInvitationForm.get('entidad').enable({onlySelf: true, emitEvent: false});
            }
            return this._dataProvider.entidadesControl;
        }
    }

    public get idiomas() {
        return this._dataProvider.idiomas;
    }

    public get timezones() {
        return this._dataProvider.timeZones;
    }

    public close() {
        this.refresh.emit(false);
    }

    public send() {
        this.checkForm();
        if (this.sendInvitationForm.valid) {
            this._auditor = {
                email: this.sendInvitationForm.get('email').value ? this.sendInvitationForm.get('email').value : null,
                idiomaId: this.sendInvitationForm.get('idioma').value ? this.sendInvitationForm.get('idioma').value.id : null,
                msTimeZoneId: this.sendInvitationForm.get('msTimeZone').value ? this.sendInvitationForm.get('msTimeZone').value.id : '',
                roleName: this.sendInvitationForm.get('permisoEscritura').value ? 'Auditor' : 'Supervisor'
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._usuariosService.enviarInvitacion(this._auditor).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.refresh.emit(true);
                this.mensaje.emit('global.success.itemCreated');
            },
            (error) => {
                this.showError = true;
                switch (error.error.ApiErrorCode) {
                    case 1010:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.emailYaExiste' });
                        break;
                    case 1012:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.yaEntidad' });
                        break;
                    case 1016:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.usuarioYaAsociadoARol' });
                        break;
                    case 1017:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.invitacionPendiente' });
                        break;
                    default:
                        this.mensajes.push({ class: 'error', message: 'ApiErrors.serverError' });
                        break;
                }
            });
        }
    }

    private checkForm() {
        this.showError = this.sendInvitationForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}

